import type { Enum } from '.';

export const ImageConfigType = {
  AKAMAI: 'AKAMAI',
  PATH: 'PATH',
} as const;
export type ImageConfigType = Enum<typeof ImageConfigType>;

export type ImageConfig = {
  match: RegExp | string;
  sizes: number[];
  type: ImageConfigType;
  path?: RegExp | string;
  qs?: string;
};

declare global {
  interface Window {
    imageSizesConfig: ImageConfig[];
  }
}
